import React, { Fragment } from 'react'

import { Route, Routes } from 'react-router-dom'

import {
  bool, object, string, shape,
} from 'prop-types'

import PageLayout from 'Pods/Layout/PageLayout'
import ContextBasedRouter from 'Pods/Shared/ContextBasedRouter'

import JobPage from './JobPage/JobPage'
import JobsList from './JobsList/JobsList'

const KNOWN_TABS = ['archive', 'inProgress', 'pending']

class JobsDashboard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      perspective: props.layout.defaultPerspective,
      tab: props.layout.defaultTab,
      title: 'Project Title',
    }

    this.updateTitle = this.updateTitle.bind(this)
  }

  componentDidCatch(error, errorInfo) {
    window.Sentry.captureException(error, { extra: errorInfo })
    window.alert(`You are not supposed to see this, please contact our support.\n${errorInfo.componentStack}`)
  }

  setPerspective(value) {
    this.setState({
      perspective: value,
    })
  }

  updateTitle(title) {
    this.setState({
      title,
    })
  }

  render() {
    const breadcrumbsList = [{
      title: 'CGTrader',
      url: '/',
      isActive: false,
    }, {
      title: 'Profile',
      url: '/profile',
      isActive: false,
    }, {
      title: 'My 3D Projects',
      url: null,
      isActive: true,
    }]

    const listButtons = (
      <Fragment>
        {this.state.perspective === 'created' ? (
          <a href="/3d-modeling-jobs/new?meta_source=projects_dashboard" className="btn btn-primary">Start a Project!</a>
        ) : (
          <a href="/3d-modeling-jobs/browse" className="btn btn-primary">Browse Projects</a>
        )}
        <div className="btn-group">
          <button
            onClick={() => this.setPerspective('applied')}
            className={this.state.perspective === 'applied' ? 'btn btn-primary' : 'btn btn-outline-default'}
          >
            Applied
          </button>
          <button
            onClick={() => this.setPerspective('created')}
            className={this.state.perspective === 'created' ? 'btn btn-primary' : 'btn btn-outline-default'}
          >
            Created
          </button>
        </div>
      </Fragment>
    )

    const breadcrumbsPage = [{
      title: 'CGTrader',
      url: '/',
      isActive: false,
    }, {
      title: 'Profile',
      url: '/profile',
      isActive: false,
    }, {
      title: '3D Projects',
      url: '/profile/projects',
      isActive: false,
    }, {
      title: this.state.title,
      url: null,
      isActive: true,
    }]

    const footerModifier = { isReduced: this.props.layout.reducedFooter }

    const jobsListElement = (tab) => (
      <PageLayout
        component={JobsList}
        navigation={this.props.navigation}
        navClass={this.props.navClass}
        navContainerClass={this.props.navContainerClass}
        navId={this.props.navId}
        breadcrumbs={breadcrumbsList}
        button={listButtons}
        perspective={this.state.perspective}
        tab={tab || this.state.tab}
        footer={footerModifier}
        newRoyaltyUi={this.props.layout.newRoyaltyUi}
      />
    )

    return (
      <ContextBasedRouter initialPathname={this.props.navigation.currentPathname}>
        <Routes>
          <Route path="/profile/projects" element={jobsListElement()} />
          {KNOWN_TABS.map((tab) => (
            <Route key={tab} path={`/profile/projects/${tab}`} element={jobsListElement(tab)} />
          ))}
          <Route
            path="/profile/projects/:id"
            element={(
              <PageLayout
                component={JobPage}
                navigation={this.props.navigation}
                navClass={this.props.navClass}
                navId={this.props.navId}
                breadcrumbs={breadcrumbsPage}
                updateTitle={this.updateTitle}
                meta={this.props.layout.meta}
                footer={footerModifier}
                newRoyaltyUi={this.props.layout.newRoyaltyUi}
              />
            )}
          />
        </Routes>
      </ContextBasedRouter>
    )
  }
}

JobsDashboard.propTypes = {
  navigation: object.isRequired,
  navClass: string.isRequired,
  navContainerClass: string.isRequired,
  navId: string.isRequired,
  layout: shape({
    defaultPerspective: string.isRequired,
    meta: object,
    reducedFooter: bool,
    newRoyaltyUi: bool,
  }).isRequired,
}

export default JobsDashboard
